import { render, staticRenderFns } from "./CreateLutFolder.vue?vue&type=template&id=60b776ab&"
import script from "./CreateLutFolder.vue?vue&type=script&lang=js&"
export * from "./CreateLutFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports